module.exports = __webpack_public_path__ + "static/media/IMG-11.38dd2c0b.jpg";